import axios from 'axios';
import API from "../helpers/api";
export default axios.create({
    baseURL: API.baseUrl,
    headers: {
    "Content-type": "application/json",
    "Accept": "application/json;odata=verbose"
    }
   });

   axios.request({
    baseURL: API.baseUrl,
    headers: {
    "Content-type": "application/json",
    "Accept": "application/json;odata=verbose"
    }
   });